import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackShowcaseBlockDeleted.meta';

export const useTrackShowcaseBlockDeleted = () => {
  const { track } = useAnalyticsUtilities();

  const trackShowcaseBlockDeleted = useCallback(() => {
    track(META.name);
  }, [track]);

  return { trackShowcaseBlockDeleted };
};
